var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (customTemplate, data, isMultiSelect) {pug_mixins["constructTemplate"] = pug_interp = function(obj, isMultiSelect, customTemplate){
var block = (this && this.block), attributes = (this && this.attributes) || {};
// iterate obj
;(function(){
  var $$obj = obj;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var val = $$obj[pug_index0];
if (val.children && val.children.length > 0 && !val.hide) {
pug_html = pug_html + "\u003Cli" + (" class=\"dropdown-submenu btn-apply\""+pug.attr("data-value", val.value, true, true)+" tabindex=\"0\""+pug.attr("data-bind", "css: {'open': $root.isVisible('" + val.value + "')}", true, true)) + "\u003E";
pug_mixins["fillDropdownContent"](val, true);
pug_html = pug_html + "\u003Cul" + (" class=\"dropdown-menu\""+pug.attr("data-bind", "visible: $root.isVisible('" + val.value + "')", true, true)) + "\u003E";
pug_mixins["constructTemplate"](val.children, isMultiSelect, customTemplate);
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fli\u003E";
}
else {
if (!val.hide) {
pug_html = pug_html + "\u003Cli" + (" class=\"btn-apply\""+" role=\"menuitem\" tabindex=\"0\""+pug.attr("data-value", val.value, true, true)) + "\u003E";
pug_mixins["fillDropdownContent"](val, false);
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
}
if (val.divider) {
pug_html = pug_html + "\u003Cdiv class=\"dropdown-divider\"\u003E\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var val = $$obj[pug_index0];
if (val.children && val.children.length > 0 && !val.hide) {
pug_html = pug_html + "\u003Cli" + (" class=\"dropdown-submenu btn-apply\""+pug.attr("data-value", val.value, true, true)+" tabindex=\"0\""+pug.attr("data-bind", "css: {'open': $root.isVisible('" + val.value + "')}", true, true)) + "\u003E";
pug_mixins["fillDropdownContent"](val, true);
pug_html = pug_html + "\u003Cul" + (" class=\"dropdown-menu\""+pug.attr("data-bind", "visible: $root.isVisible('" + val.value + "')", true, true)) + "\u003E";
pug_mixins["constructTemplate"](val.children, isMultiSelect, customTemplate);
pug_html = pug_html + "\u003C\u002Ful\u003E\u003C\u002Fli\u003E";
}
else {
if (!val.hide) {
pug_html = pug_html + "\u003Cli" + (" class=\"btn-apply\""+" role=\"menuitem\" tabindex=\"0\""+pug.attr("data-value", val.value, true, true)) + "\u003E";
pug_mixins["fillDropdownContent"](val, false);
pug_html = pug_html + "\u003C\u002Fli\u003E";
}
}
if (val.divider) {
pug_html = pug_html + "\u003Cdiv class=\"dropdown-divider\"\u003E\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

};
pug_mixins["displayCustomTemplate"] = pug_interp = function(val){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var properties = {};
var defaultProps = ['children', 'parent', 'selected', 'showChildren', 'element'];
// iterate val
;(function(){
  var $$obj = val;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var value = $$obj[index];
if (defaultProps.indexOf(index) === -1) {
properties[index] = value;
}
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var value = $$obj[index];
if (defaultProps.indexOf(index) === -1) {
properties[index] = value;
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003Cdiv style=\"display: inline-block\"\u003E" + (null == (pug_interp = customTemplate(properties)) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
};
pug_mixins["fillDropdownContent"] = pug_interp = function(val, showRightArrow){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["dropdown-menuitem",typeof val.disabled === 'undefined' && !val.disabled ? "" : "disabled"], [false,true]), false, true)+" role=\"menuitem\" data-toggle=\"dropdown\"") + "\u003E";
if (showRightArrow) {
pug_html = pug_html + "\u003Cspan class=\"glyphicon glyphicon-triangle-right toolbar-icon grid-expand-icon pull-right\"\u003E\u003C\u002Fspan\u003E";
}
if (val.view) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["view-template","sc-dropdown-" + val.value], [false,true]), false, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else {
if (isMultiSelect) {
pug_html = pug_html + "\u003Cinput" + (" type=\"checkbox\" style=\"display: inline-block\""+pug.attr("data-bind", "checked: $root.isSelected('" + val.value + "')", true, true)) + "\u003E";
}
else {
pug_html = pug_html + "\u003Cspan" + (" class=\"glyphicon glyphicon-position\""+" tabindex=\"-1\""+pug.attr("data-bind", "css: { 'glyphicon-ok': $root.isSelected('" + val.value + "')}", true, true)) + "\u003E\u003C\u002Fspan\u003E";
}
if (!customTemplate) {
pug_html = pug_html + "\u003Cspan\u003E" + (pug.escape(null == (pug_interp = val.text) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E";
}
else {
pug_mixins["displayCustomTemplate"](val);
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["constructTemplate"](data, isMultiSelect, customTemplate);}.call(this,"customTemplate" in locals_for_with?locals_for_with.customTemplate:typeof customTemplate!=="undefined"?customTemplate:undefined,"data" in locals_for_with?locals_for_with.data:typeof data!=="undefined"?data:undefined,"isMultiSelect" in locals_for_with?locals_for_with.isMultiSelect:typeof isMultiSelect!=="undefined"?isMultiSelect:undefined));;return pug_html;};
module.exports = template;